import '../plugins/slickPlugin';

// slick init
export default function initM17() {
  $(function () {
    if ($('.module-m17').length > 0) {
      $('.module-m17').each(function () {
        let $module = $(this);
        $module.find('.module-m17-slider').slick({
          infinite: true,
          slidesToScroll: 1,
          slidesToShow: 3,
          dots: true,
          arrows: false,
          // waitForAnimate: false,
          appendDots: $module.find('.module-m17-slider-dots'),
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      });
    }
  });
}
